const Condition = require( './Condition' );
const BattleCalc = require( '../BattleCalc' );

const StunnedCondition = function( instigator, owner, battleState, duration ) {
	const condition = new Condition( instigator, owner, battleState );
	condition.handle = 'stunned';
	condition.duration = duration;

	const extant = BattleCalc.getCondition( owner, 'stunned' );
	if( extant ) {
		battleState.expireCondition( extant.uid );
	}

	condition.initInterval( condition.expire, duration );
	if( battleState.paused ) {
		condition.intervalTimer.pause();
	}

	return condition;
};
module.exports = StunnedCondition
